<template>
  <div>
    <div v-if="formOpen">
      <my-form
        v-if="formActionType !== ''"
        :formActionType="formActionType"
        fromReference
        :type="gridType"
        @close="formOpen = false"
        @editOk="editOk"
        @addOk="addOk"
      ></my-form>
    </div>
    <el-dialog
      :visible.sync="infoDialogOpen"
      v-if="infoDialogOpen"
      :title="$t('referenceGrid.bindsInfo')"
      center
      width="60%"
    >
      <div v-if="gridType === 'db'">
        <b>{{ $t("referenceGrid.appsToWhichBaseLinked") + ":" }}</b>
        <div
          v-for="(sect, index) in getSectionsInBaseArray"
          :key="index"
          style="padding-left: 5px"
        >
          &#8226;
          <span>{{ sect.name }};</span>
        </div>
        <br />
        <div v-if="getSectionsInBaseArray.length > 0">
          {{ $t("referenceGrid.toUnlinkAppsGoToDeleteMenu") }}
        </div>
        <div v-else>{{ $t("referenceGrid.currentBaseNotLinkedToApp") }}</div>
      </div>
      <div v-if="gridType === 'app'">
        <b>{{ $t("referenceGrid.basesLinkedToApp") + ":" }}</b>
        <div
          v-for="(base, index) in getBasesInSection"
          :key="index"
          style="padding-left: 5px"
        >
          &#8226;
          <span>{{ baseLabel(base) }}</span>
        </div>
        <br />
        <div v-if="getBasesInSection.length > 0">
          {{ $t("referenceGrid.toUnlinkBasesGoToDeleteMenu") }}
        </div>
        <div v-else>{{ $t("referenceGrid.noLinkedBasesToCurrentApp") }}</div>
        <br />
        <b>{{ $t("referenceGrid.packetsWithSection") + ":" }}</b>
        <div
          v-for="packet in sectionPackets"
          :key="packet.name"
          style="padding-left: 5px"
        >
          &#8226;
          <span>{{ packet.name }}</span>
        </div>
        <br />
        <div v-if="sectionPackets.length > 0">
          {{ $t("referenceGrid.toDeletePackets") }}
        </div>
        <div v-else>{{ $t("referenceGrid.noPacketsWithSection") }}</div>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="copySectionDialog"
      v-if="currentRowSelected && copySectionDialog"
    >
      <span slot="title" class="delete-dialog-title">
        <div>
          {{
            $t("referenceGrid.enterDataForNewApp") +
            ". " +
            $t("referenceGrid.copied") +
            ":"
          }}
        </div>
        <div class="delete-dialog-element-name">
          {{ currentRowSelected.sectionName }}
        </div>
      </span>
      <div>{{ $t("referenceGrid.copyAttention") }}</div>
      <el-form :model="copySectionData" :rules="copyRules" ref="copyForm">
        <el-form-item :label="$t('referenceGrid.name')" prop="name">
          <el-input v-model="copySectionData.name"></el-input>
        </el-form-item>
        <el-form-item :label="$t('referenceGrid.alias')" prop="alias">
          <el-input v-model="copySectionData.alias"></el-input>
        </el-form-item>
        <el-form-item :label="$t('referenceGrid.path')" prop="path">
          <el-input v-model="copySectionData.path"></el-input>
        </el-form-item>
      </el-form>
      <div class="buttons-bottom">
        <div></div>
        <div>
          <el-button
            class="button-cancel"
            type="plain"
            @click="copySectionDialog = false"
            >{{ $t("referenceGrid.cancel") }}</el-button
          >
          <el-button
            class="button-confirm"
            type="success"
            @click="okClickSectionCopy"
            >ОК</el-button
          >
        </div>
      </div>
    </el-dialog>
    <div class="buttons-grid" v-if="gridType !== 'upgrades'">
      <!-- <el-button class="el-icon-">Скачать</el-button> -->

      <el-tooltip
        class="item"
        effect="light"
        :content="$t('referenceGrid.insert')"
        placement="bottom-start"
      >
        <span>
          <el-button
            @click="createClick"
            class="el-icon-plus"
            type="primary"
            :disabled="addDisabled"
          ></el-button>
        </span>
      </el-tooltip>
      <el-tooltip
        class="item"
        effect="light"
        :content="$t('referenceGrid.copy')"
        placement="bottom-start"
      >
        <span>
          <el-button
            @click="copyClick"
            v-if="gridType === 'app'"
            :disabled="buttonDisabled"
            type="primary"
            class="el-icon-copy-document"
          ></el-button>
        </span>
      </el-tooltip>
      <el-tooltip
        class="item"
        effect="light"
        :content="$t('referenceGrid.info')"
        placement="bottom-start"
      >
        <span>
          <el-button
            @click="infoClick"
            v-if="gridType === 'db' || gridType === 'app'"
            :disabled="buttonDisabled"
            class="el-icon-info"
            type="primary"
          ></el-button>
        </span>
      </el-tooltip>
      <el-tooltip
        class="item"
        effect="light"
        :content="$t('referenceGrid.edit')"
        placement="bottom-start"
      >
        <span>
          <el-button
            @click="editClick"
            class="el-icon-edit"
            type="primary"
            :disabled="buttonDisabled"
          ></el-button>
        </span>
      </el-tooltip>
      <el-tooltip
        class="item"
        effect="light"
        :content="$t('referenceGrid.delete')"
        placement="bottom-start"
      >
        <span>
          <el-button
            @click="deleteClick"
            class="el-icon-delete"
            type="danger"
            :disabled="buttonDisabled"
          ></el-button>
        </span>
      </el-tooltip>
      <el-dropdown trigger="click">
        <el-button type="plain" size="small" class="view-dropdown">
          {{ $t("referenceGrid.view") }}
          <i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="optimalViewBtn">{{
            $t("referenceGrid.compact")
          }}</el-dropdown-item>
          <el-dropdown-item @click.native="fullViewBtn">{{
            $t("referenceGrid.full")
          }}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

    <el-row type="flex" justify="space-between">
      <el-col :span="24" class="grid-container-full">
        <ag-grid-vue
          style="
            width: 100%;
            height: 100%;
            font-family: 'Open Sans', sans-serif;
          "
          class="ag-theme-balham"
          :columnDefs="columnDefs"
          :rowData="gridData"
          :defaultColDef="defaultColDef"
          rowSelection="single"
          :localeText="agGridlocaleText"
          suppressCellSelection
          @grid-ready="onGridReady"
          @first-data-rendered="onGridFirstDataRendered"
          @gridSizeChanged="onGridSizeChanged"
          @column-resized="onColumnResized"
          @row-data-changed="onGridDataChanged"
          @rowSelected="onRowSelected"
        ></ag-grid-vue>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Form from "../config/form_elements/Form";
// import "ag-grid-community/dist/styles/ag-grid.css";
// import "ag-grid-community/dist/styles/ag-theme-balham.css";
import agGridLocaleRu from "@/locales/ru/agGrid";
import agGridLocaleUa from "@/locales/ua/agGrid";
import agGridLocaleEn from "@/locales/en/agGrid";
import i18n from "@/locales";
import { AgGridVue } from "ag-grid-vue";
import { mapGetters } from "vuex";
export default {
  data() {
    const validateName = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t("referenceGrid.enterNameForNewApp")));
      } else if (value.trim().includes(" ")) {
        callback(new Error(this.$t("errors.nameHasSpace")));
      } else {
        callback();
      }
    };
    const validatePath = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t("referenceGrid.enterPathForNewApp")));
      } else if (value.trim().includes(" ")) {
        callback(new Error(this.$t("errors.nameHasSpace")));
      } else {
        callback();
      }
    };
    return {
      buttonDisabled: true,
      addDisabled: false,
      formOpen: false,
      infoDialogOpen: false,
      agGridlocaleText: null,
      columnDefs: null,
      defaultColDef: null,
      gridApi: null,
      columnApi: null,
      settings: null,
      currentRowSelected: null,
      currentId: null,
      formActionType: "",
      //данные отрендерились в первый раз (для того, чтобы потом выключать loading при обновлении)
      firstRenderFlag: false,
      copySectionDialog: false,
      copySectionData: {
        name: null,
        alias: null,
        path: null,
      },
      copyRules: {
        name: {
          required: true,
          validator: validateName,
          trigger: "blur",
        },
        alias: {
          required: false,
        },
        path: {
          required: true,
          validator: validatePath,
          trigger: "blur",
        },
      },
    };
  },
  methods: {
    // this.gridApi.refreshCells(); // обновление данных
    createClick() {
      this.formActionType = "add";
      this.formOpen = true;
    },
    editClick() {
      this.$store.commit("setLoading", true);
      this.formActionType = "edit";
      // this.buttonDisabled = true;
      let getFn = "";
      if (this.gridType === "server") {
        getFn = "getServerInfo";
      } else if (this.gridType === "app") {
        getFn = "getSectionInfo";
      } else if (this.gridType === "db") {
        getFn = "getBaseInfo";
      } else if (this.gridType === "user") {
        this.$store.commit("setCurInfo", this.currentRowSelected);
        this.formOpen = true;
        this.$store.commit("setLoading", false);
        return;
      } else if (this.gridType === "param") {
        this.$store.commit("setCurInfo", this.currentRowSelected);
        this.formOpen = true;
        this.$store.commit("setLoading", false);
        return;
      } else if (this.gridType === "role") {
        this.$store.commit("setCurInfo", this.currentRowSelected);
        this.formOpen = true;
        this.$store.commit("setLoading", false);
        return;
      }
      this.$store
        .dispatch("getInfo", {
          id: this.currentId,
          getFn,
        })
        .then(() => {
          this.formOpen = true;
        })
        .then(() => {
          this.$store.commit("setLoading", false);
        })
        .catch(() => {
          this.$store.commit("setLoading", false);
        });
    },
    deleteClick() {
      let title = "";
      if (this.gridType === "db") {
        title = this.currentRowSelected.baseName;
      } else if (this.gridType === "app") {
        title = this.currentRowSelected.sectionName;
      } else if (this.gridType === "server") {
        title = this.currentRowSelected.serverName;
      } else if (this.gridType === "user") {
        title =
          this.currentRowSelected.login +
          " - " +
          this.currentRowSelected.fullName;
      } else if (this.gridType === "param") {
        title = this.currentRowSelected.name;
      } else if (this.gridType === "role") {
        title = this.currentRowSelected.name;
      }
      this.$emit("deleteClicked", { currentId: this.currentId, title });
      this.buttonDisabled = true;
      this.gridApi.deselectAll();
    },
    addOk(value) {
      //console.log("addOk", value);
      // this.buttonDisabled = true;
      let createFunction = "";
      let dispatchFunction = "";
      this.formOpen = false;
      this.$store.commit("setLoading", true);
      if (this.gridType === "db") {
        createFunction = "createBase";
        dispatchFunction = "getBaseTable";
      } else if (this.gridType === "app") {
        createFunction = "insSectionTable";
        dispatchFunction = "getSectionTable";
      } else if (this.gridType === "server") {
        createFunction = "createServer";
        dispatchFunction = "getServerTable";
      } else if (this.gridType === "user") {
        createFunction = "createUser";
        dispatchFunction = "getUserTable";
      } else if (this.gridType === "param") {
        createFunction = "createAppParam";
        dispatchFunction = "getAppParamTable";
      } else if (this.gridType === "role") {
        createFunction = "createRole";
        dispatchFunction = "getRoleTable";
      }
      this.$store
        .dispatch(createFunction, value)
        .then(() => {
          return this.$store.dispatch(dispatchFunction);
        })
        .catch(() => {
          this.$store.commit("setLoading", false);
        });
    },
    editOk(value) {
      this.formOpen = false;
      // this.buttonDisabled = true;
      this.$store.commit("setLoading", true);
      //console.log(value);
      if (value[4] != null && this.gridType === "user") {
        this.$store
          .dispatch("changePassword", {
            newPassword: value[4],
            userId: this.currentId,
            oldPassword: "",
          })
          .then(() => {
            return this.$store.dispatch("getUserTable");
          })
          .then(() => {
            this.buttonDisabled = true;
          })
          .catch(() => {
            this.$store.commit("setLoading", false);
            return;
          });
      }
      if (
        value[5] != null &&
        this.gridType === "user" &&
        value[5] !== this.currentRowSelected.idRole
      ) {
        this.$store
          .dispatch("changeUserRole", {
            userid: this.currentId,
            roleid: value[5],
          })
          .then(() => {
            return this.$store.dispatch("getUserTable");
          })
          .then(() => {
            this.buttonDisabled = true;
          })
          .catch(() => {
            this.$store.commit("setLoading", false);
            return;
          });
      }
      value.unshift(this.currentId);
      let updFn = "";
      let getFn = "";
      if (this.gridType === "db") updFn = "updBaseTable";
      else if (this.gridType === "app") updFn = "updSectionTable";
      else if (this.gridType === "server") updFn = "updServerTable";
      else if (this.gridType === "user") {
        updFn = "updUser";
        value.pop(); //убираем пароль и роль из массива для обновления пользователя
        value.pop();
      } else if (this.gridType === "param") {
        updFn = "updParamTable";
        value.push(value[1]);
      } else if (this.gridType === "role") {
        updFn = "updRoleTable";
      }
      getFn = updFn.replace("upd", "get");
      if (this.gridType === "user") getFn = "getUserTable";
      else if (this.gridType === "param") getFn = "getAppParamTable";
      else if (this.gridType === "role") getFn = "getRoleTable";
      if (updFn !== "") {
        this.$store
          .dispatch("updTable", {
            updArray: value,
            updFn,
          })
          .then(() => {
            //обновляем данные
            return this.$store.dispatch(getFn);
          })
          .then(() => {
            this.buttonDisabled = true;
          })
          .catch(() => {
            this.$store.commit("setLoading", false);
          });
      }
    },
    copyClick() {
      this.copySectionDialog = true;
      this.copySectionData = {
        name: null,
        alias: null,
        path: null,
      };
    },
    infoClick() {
      if (this.gridType === "db") {
        this.$store
          .dispatch("getSectionsInBase", this.currentId)
          .then(() => {
            this.infoDialogOpen = true;
            // console.log(this.getSectionsInBaseArray);
          })
          .catch((err) => {
            console.error(err);
          });
      } else if (this.gridType === "app") {
        this.$store
          .dispatch("getBasesSection", this.currentId)
          .then(() => {
            return this.$store.dispatch("getSectionPackets", this.currentId);
            // console.log(this.getBasesInSection);
          })
          .then(() => {
            this.infoDialogOpen = true;
          })
          .catch((err) => {
            console.error(err);
          });
      }
    },
    sendCopyData({ name, alias, path, origID }) {
      this.$store.commit("setLoading", true);
      // //console.log(this.copySectionData);
      // //console.log(this.currentId);
      this.$store
        .dispatch("copySection", {
          name,
          alias,
          path,
          origID,
        })
        .then(() => {
          this.copySectionDialog = false;
          this.copySectionData.name = null; // удалить все заполненные значения
          this.copySectionData.alias = null; // удалить все заполненные значения
          this.copySectionData.path = null; // удалить все заполненные значения
          return this.$store.dispatch("getSectionTable");
        })
        .then(() => {
          this.$store.commit("setLoading", false);
        })
        .catch(() => {
          this.$store.commit("setLoading", false);
        });
    },
    okClickSectionCopy() {
      if (!!this.copySectionData.name)
        this.copySectionData.name = this.copySectionData.name.trim();
      if (!!this.copySectionData.path)
        this.copySectionData.path = this.copySectionData.path.trim();
      if (!!this.copySectionData.alias)
        this.copySectionData.alias = this.copySectionData.alias.trim();

      this.$refs.copyForm.validate((valid) => {
        if (valid) {
          if (this.copySectionData.alias === null) {
            this.$confirm(
              `${this.$t("referenceGrid.desirableEnterAliasField")}. ${this.$t(
                "referenceGrid.continueWithoutAlias"
              )}?`,
              this.$t("referenceGrid.attention"),
              {
                confirmButtonText: this.$t("referenceGrid.attention"),
                cancelButtonText: this.$t("referenceGrid.return"),
                type: "info",
              }
            )
              .then(() => {
                this.sendCopyData({
                  name: this.copySectionData.name,
                  alias: "null",
                  path: this.copySectionData.path,
                  origID: this.currentId,
                });
              })
              .catch(() => {
                this.copySectionDialog = true;
                // this.copySectionData.name = name; // вернуть все заполненные значения
                // this.copySectionData.path = path;
              });
          } else {
            this.sendCopyData({
              name: this.copySectionData.name,
              alias: this.copySectionData.alias,
              path: this.copySectionData.path,
              origID: this.currentId,
            });
          }
        }
      });
    },
    optimalViewBtn() {
      this.gridApi.sizeColumnsToFit();
      this.settings.grids.packs.viewFull = false;
    },
    fullViewBtn() {
      let allColumnIds = [];
      this.columnApi
        .getAllColumns()
        .forEach((column) => allColumnIds.push(column.colId));
      this.columnApi.autoSizeColumns(allColumnIds);
      this.settings.grids.packs.viewFull = true;
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.columnApi = params.columnApi;
      this.gridApi.setEnableCellTextSelection(true);
    },
    onGridSizeChanged(params) {
      params.api.sizeColumnsToFit();
      // this.autoSizeAll();
    },
    onGridDataChanged() {
      if (this.firstRenderFlag) this.$store.commit("setLoading", false);
    },
    onColumnResized(params) {
      params.api.resetRowHeights();
    },
    onGridFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
      this.$store.commit("setLoading", false);
      this.firstRenderFlag = true;
    },
    onRowSelected(params) {
      // //console.log(params);
      if (params.node.selected) {
        this.currentRowSelected = params.node.data; // текущая выбранная строка грида запоминается в буфере
        this.currentId = Object.values(this.currentRowSelected)[0];
        // console.log("CURRENT ROW: ", this.currentRowSelected);
        if (
          this.gridType === "role" &&
          this.getUser.roleid !== "0" &&
          (this.currentRowSelected.id === "0" ||
            this.currentRowSelected.id === "1")
        ) {
          this.buttonDisabled = true;
        } else if (!this.isAllowed) {
          this.buttonDisabled = true;
        } else {
          this.buttonDisabled = false;
        }
      }
    },
    baseLabel(base) {
      let label = base.bname;
      if (base.balias && base.comment) {
        label += " (" + base.balias + ") -- " + base.comment;
      } else if (base.balias) label += " (" + base.balias + ")";
      else if (base.comment) label += " -- " + base.comment;
      return label;
    },
  },
  beforeMount() {
    this.columnDefs = this.columns;
    const locale = i18n.locale;
    switch (locale) {
      case "ru":
        this.agGridlocaleText = agGridLocaleRu;
        break;
      case "ua":
        this.agGridlocaleText = agGridLocaleUa;
        break;
      case "en":
        this.agGridlocaleText = agGridLocaleEn;
        break;
      default:
        this.agGridlocaleText = agGridLocaleRu;
    }

    this.defaultColDef = {
      resizable: true,
      sortable: true,
      filter: true,
      autoHeight: true,
    };
    this.settings = {
      grids: {
        packs: {
          viewFull: false,
        },
      },
    };
    if (!this.isAllowed) {
      this.addDisabled = true;
      this.buttonDisabled = true;
    }
    if (this.gridData.length === 0) {
      this.$store.commit("setLoading", false);
    }
  },
  /*gridType -> db, app, server, user*/
  watch: {
    gridData() {
      //console.log("refreshing");
      if (this.gridApi) this.gridApi.refreshCells(); // обновление данных
    },
  },
  props: ["gridData", "columns", "gridType"],
  components: {
    AgGridVue,
    myForm: Form,
  },
  computed: {
    ...mapGetters([
      "getRTRetFile",
      "getSectionsInBaseArray",
      "getBasesInSection",
      "getUser",
      "sectionPackets",
    ]),
    isAllowed() {
      if (
        this.gridType === "user" &&
        this.getUser &&
        this.getUser.userid !== "0" &&
        this.getUser.userid !== "1"
      ) {
        return false;
      } else if (
        this.gridType === "user" &&
        this.getUser &&
        (this.getUser.userid === "0" || this.getUser.userid === "1")
      ) {
        return true;
      } else return true;
    },
  },
};
</script>

<style scoped>
.delete-dialog-element-name {
  font-weight: 600;
  text-align: center;
}
</style>